import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=f9607b40&scoped=true"
import script from "./Security.ts?vue&type=script&lang=ts&external"
export * from "./Security.ts?vue&type=script&lang=ts&external"
import style0 from "./Security.vue?vue&type=style&index=0&id=f9607b40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9607b40",
  null
  
)

export default component.exports